import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface SolarProduct {
  title: string;
  desc: string;
}

export interface ChatMessage {
  id: number;
  sender: 'user' | 'bot';
  text?: string;
  loanTypes?: string[];
  lenders?: string[];
  solarProducts?: SolarProduct[];
  solarRequirements?: string[];
  timestamp: string;
  delayMs?: number;
}

@Component({
  selector: 'app-outreach-chat-bot',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './outreach-chat-bot.component.html',
  styleUrl: './outreach-chat-bot.component.scss',
})
export class OutreachChatBotComponent {
  isOpen = true;
  isMinimized = false;
  isMaximized = false;
  userInputValue = '';
  isTyping = false;

  loanOptions: string[] = [
    'Term Loan',
    'Working Capital Loan',
    'Loan to purchase or upgrade a business facility or equipment',
    'Refinance other Debt',
    'Real Estate Lending (residential)',
    'Commercial Real Estate Purchase',
    'Start-up Support',
    'Short-term quick capital',
    'Business Acquisition',
    'Grant Programs',
    'Venture Funding (Debt, equity, or Revenue Share)',
    'Acquisition / M&A',
    'Project Finance',
  ];

  messages: ChatMessage[] = [
    {
      id: 1,
      sender: 'user',
      text: 'I am looking for a loan. What types of loans are available?',
      timestamp: '10:24 AM',
    },
    {
      id: 2,
      sender: 'bot',
      text: 'We partner with lenders offering a wide variety of financing options tailored to your business needs:',
      loanTypes: [
        'Term Loan',
        'Working Capital Loan',
        'Loan to purchase or upgrade a business facility or equipment',
        'Refinance other Debt',
        'Real Estate Lending (residential)',
        'Commercial Real Estate Purchase',
        'Start-up Support',
        'Short-term quick capital',
        'Business Acquisition',
        'Grant Programs',
        'Venture Funding (Debt, equity, or Revenue Share)',
        'Acquisition / M&A',
        'Project Finance',
      ],
      timestamp: '10:24 AM',
    },
    {
      id: 3,
      sender: 'user',
      text: 'Which lenders in NC area provide loans between $25,000 and $100,000?',
      timestamp: '10:25 AM',
    },
    {
      id: 4,
      sender: 'bot',
      text: 'Institute Capital and Mountain BizWorks does provide loans of that size',
      lenders: ['Institute Capital', 'Mountain BizWorks'],
      timestamp: '10:25 AM',
    },
    {
      id: 5,
      sender: 'user',
      text: 'Looking to purchase solar panels for our facility and improve energy efficiency.',
      timestamp: '10:26 AM',
    },
    {
      id: 6,
      sender: 'bot',
      text: 'Based on your goal to secure financing for solar panels and energy efficiency upgrades, here are the best-fit products and key requirements:',
      solarProducts: [
        {
          title: 'Solar & Energy Efficiency Financing',
          desc: 'Loans & support for solar panel installations and clean energy projects.',
        },
        {
          title: 'Commercial Real Estate Financing',
          desc: 'Funding for commercial facility upgrades and energy retrofits.',
        },
      ],
      solarRequirements: [
        'Business Entity Documentation',
        'Credit Score Info (580+)',
        'Power Use Statements',
        'Project Details & Quotes',
        'Ownership / Lease Terms',
        'Business Plan & Projections',
        'Financial Statements',
      ],
      timestamp: '10:26 AM',
    },
  ];

  toggleChat(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.isMinimized = false;
    }
  }

  minimizeChat(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = false;
  }

  toggleMaximize(event: MouseEvent): void {
    event.stopPropagation();
    this.isMaximized = !this.isMaximized;
  }

  onSendMock(): void {
    if (!this.userInputValue.trim()) return;
    const userMsgText = this.userInputValue;
    this.userInputValue = '';

    const newId = this.messages.length + 1;
    const now = new Date();
    const timeStr = now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    this.messages.push({
      id: newId,
      sender: 'user',
      text: userMsgText,
      timestamp: timeStr,
    });

    this.isTyping = true;
    setTimeout(() => {
      this.isTyping = false;
      this.messages.push({
        id: newId + 1,
        sender: 'bot',
        text: `Thank you for reaching out! Our team and automated matching engine can assist you with details regarding ${userMsgText}. Please fill out the DeepRoots form above to get matched.`,
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        }),
      });
    }, 1200);
  }
}
